import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdfa5ecc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar-search-bar" }
const _hoisted_2 = { class: "open-search-button__text .d-md-none" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-search",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "navbar-search-sidebar"
}
const _hoisted_5 = { class: "content-container" }
const _hoisted_6 = { class: "input-container input-group" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "input-group-append" }
const _hoisted_9 = {
  class: "d-none",
  value: null,
  disabled: "",
  selected: ""
}
const _hoisted_10 = { value: null }
const _hoisted_11 = ["value"]
const _hoisted_12 = { id: "result-count__number" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-file-earmark-text",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" })
  ])
], -1))
const _hoisted_14 = { class: "result-content" }
const _hoisted_15 = { class: "result-title" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "result-section" }
const _hoisted_18 = { class: "result-excerpt" }
const _hoisted_19 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_circle = _resolveComponent("loading-circle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      id: "open-search-button",
      class: "btn open-search-button",
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openSidebar && _ctx.openSidebar(...args)))
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('navbar.search.buttonText')), 1),
      _hoisted_3
    ]),
    (_ctx.isSidebarOpened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            id: "backdrop",
            class: "backdrop",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args)))
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.debouncedSearch && _ctx.debouncedSearch(...args))),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchInput) = $event)),
                ref: "sidebarInput",
                class: "form-control",
                type: "text",
                placeholder: _ctx.$t('navbar.search.inputPlaceholder')
              }, null, 40, _hoisted_7), [
                [_vModelText, _ctx.searchInput]
              ]),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedSection) = $event)),
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.debouncedSearch && _ctx.debouncedSearch(...args))),
                  class: "section-select custom-select"
                }, [
                  _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t('navbar.search.sectionSelectPlaceholder')), 1),
                  _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$t('navbar.search.allSectionsOption')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchSections, (section) => {
                    return (_openBlock(), _createElementBlock("option", { value: section }, _toDisplayString(section.name), 9, _hoisted_11))
                  }), 256))
                ], 544), [
                  [_vModelSelect, _ctx.selectedSection]
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["result-count", {'invisible': _ctx.totalCount < 0 }])
            }, [
              _createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.totalCount), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('navbar.search.searchResults')), 1)
              ])
            ], 2),
            _createElementVNode("div", {
              onScroll: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args))),
              class: "search-results"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (result) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: result.url + result.title
                }, [
                  _createVNode(_component_router_link, {
                    to: _ctx.transformUrl(result.url),
                    onClick: _ctx.closeSidebar,
                    class: "search-result"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("span", {
                            innerHTML: _ctx.sanitize(result.title)
                          }, null, 8, _hoisted_16)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t(result.section.name)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", {
                            innerHTML: _ctx.sanitize(result.excerpt)
                          }, null, 8, _hoisted_19)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to", "onClick"])
                ]))
              }), 128)),
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_loading_circle, { key: 0 }))
                : _createCommentVNode("", true)
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}